export default "__VITE_ASSET__BskbtQ4u__"